import { SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

interface ReviewVisitTableHeaderCellProps {
    children?: ReactNode;
    sx?: SxProps;
}

export function ReviewVisitTableHeaderCell({ children, sx }: ReviewVisitTableHeaderCellProps) {
    return (
        <Typography
            variant="body2"
            sx={[
                theme => ({
                    fontWeight: "bold",
                    paddingInline: 2,
                    paddingBlock: 1,
                    backgroundColor: theme.palette.background.default,
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Typography>
    );
}
